import React from "react";
import { Form } from "react-bootstrap";
import SelectDropdown from "./SelectDropdown";

const AspectRatioComponent = ({
  aspectRatioList,
  updateAspectRatio,
  aspectRatio,
}) => {
  return (
    <div className="aspect-ratio-container">
      <Form.Label>Set Aspect Ratio</Form.Label>
      <SelectDropdown
        placeholder="Select Aspect Ratio"
        menuList={aspectRatioList}
        onMenuSelect={updateAspectRatio}
        value={aspectRatio}
      />
    </div>
  );
};

export default AspectRatioComponent;
